import script from "./InfoDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoDisplay.vue?vue&type=script&setup=true&lang=js"

import "./InfoDisplay.vue?vue&type=style&index=0&id=70756296&lang=scss"

const __exports__ = script;

export default __exports__